/**
 * api管理文件
 * 可根据模块拆分为多个文件
 */
const apimap = [
    // 全部插件列表
    {
        id: 'getAllExtension',
        url: '/api/organization/{{organizationId}}/object/{{objectId}}/extensions',
        method: 'get',
    },
    // 已启用插件列表
    {
        id: 'getAvailableExtension',
        url: '/api/organization/{{organizationId}}/extensions/available',
        method: 'get',
    },
    // 开启/关闭插件
    {
        id: 'enableExtension',
        url: '/api/organization/{{organizationId}}/object/{{objectId}}/app/{{appId}}/enable',
        method: 'put',
    },
    // 获取配置信息
    {
        id: 'getSetting',
        url: '/api/organization/{{organizationId}}/app/{{appId}}/object/{{objectId}}/setting',
        method: 'get',
    },
    // 更新配置
    {
        id: 'putSetting',
        url: '/api/organization/{{organizationId}}/app/{{appId}}/object/{{objectId}}/setting',
        method: 'put',
    },
    // 获取基础配置
    {
        id: 'basicSetting',
        url: '/api/sdk/configs',
        method: 'get',
    }
];
export default apimap;
